import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Clipboard from 'react-copy-to-clipboard'

export default class Copy extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired
  }

  state = {
    copied: false
  }

  copyHandler = (text, copied) => this.setState({ copied })

  render() {
    const { text, ...props } = this.props
    const { copied } = this.state
    return (
      <Clipboard text={text} onCopy={this.copyHandler}>
        <a className="button" {...props}>{ copied ? 'Copied' : 'Copy' }</a>
      </Clipboard>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/Hotsheets/Copy.js